import { useCallback, useEffect, useState } from "react";
import {
  fetchSupplierGroups, fetchSuppliersByGroups, previewSupplierMessage, sendToSuppliers,
} from "../../models/suppliers/suppliersModel";

export function useSuppliers() {
  const [groups, setGroups] = useState([]);
  const [groupsLoading, setGroupsLoading] = useState(true);
  const [suppliers, setSuppliers] = useState([]);
  const [suppliersLoading, setSuppliersLoading] = useState(false);

  useEffect(() => {
    fetchSupplierGroups().then(list => {
      setGroups(list);
      setGroupsLoading(false);
    });
  }, []);

  const loadSuppliers = useCallback(async (groupIds) => {
    if (!groupIds?.length) {
      setSuppliers([]);
      return [];
    }
    setSuppliersLoading(true);
    const list = await fetchSuppliersByGroups(groupIds);
    setSuppliers(list);
    setSuppliersLoading(false);
    return list;
  }, []);

  const preview = useCallback((args) => previewSupplierMessage(args), []);
  const send = useCallback((payload) => sendToSuppliers(payload), []);

  return { groups, groupsLoading, suppliers, suppliersLoading, loadSuppliers, preview, send };
}
